export default __webpack_public_path__ + "static/media/benicia.85339b5c.jpg";